module.exports = __webpack_public_path__ + "static/museum-ba8c28784b07d242af8fc8b1e9810b3d.jpg";